import { FintechStrategyIcon } from '@/svgs'
import React from 'react'

function FiFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <p className="section_heading_title mb-3">
               From Strategy to Execution:
               <br />
               Our FinTech Software Development Process
            </p>

            <p className="section_desc">
               With 12+ years of experience in developing FinTech financial software, we provide high-performing, secure, and scalable financial solutions. Our well-crafted approach ensures compliance, enhances business performance, and facilitates digital change in the finance industry.
            </p>

            <FintechStrategyIcon />
         </div>
      </section>
   )
}

export default FiFromStrategy
